export const PAYMENT = {
  ERROR: 'PaymentError',
  PAY_BUTTON_CLICK: 'PaymentPayButtonClick',
};

export const SURCHARGE = {
  ERROR: 'SurchargeError',
  PAY_BUTTON_CLICK: 'SurchargePayButtonClick',
};

export const FAST_CASH = {
  OPEN: 'FastCashOpen',
  TERM_CHANGE: 'FastCashTermChange',
  REQUEST_APPROVAL: 'FastCashRequestApprovalButtonClick',
  PROCEED: 'FastCashProceedToLoan',
};

export const WHATS_APP_CLICK = 'WhatsAppClick';
export const DESKTOP_PLUG_OPEN_SUCCESS = 'DesktopPlugOpenSuccess';
export const BURGER_MENU_CLICK = 'BurgerMenuClick';

export const KGF = {
  PREFIX: 'KGF',
  MAIN: {
    LOAD: {
      SUCCESS: 'MainLoadSuccess',
    },
    LOGO_CLICK: 'MainLogoClick',
    ANCHOR_LINKS: 'MainAnchorLinks',
    FULL_RULES_CLICK: 'MainFullRulesClick',
    CALL_BUTTON_CLICK: 'MainCallButtonClick',
    REQUEST_BUTTON_CLICK: 'MainRequestButtonClick',
    NAVIGATE_TO_MAIN_FLOW: 'MainNavigateToMainFlowButtonClick',
    SEARCH_FORM: {
      DEP: {
        CLICK: 'MainSearchFormDepartureClick',
        SELECT: 'MainSearchFormDepartureSelect',
      },
      ARR: {
        CLICK: 'MainSearchFormArrivalClick',
        SELECT: 'MainSearchFormArrivalSelect',
      },
      STARS: {
        CLICK: 'MainSearchFormStarsClick',
        SELECT: 'MainSearchFormStarsSelect',
      },
      PASSENGERS: {
        CLICK: 'MainSearchFormPassengersClick',
        SELECT: 'MainSearchFormPassengersSelect',
      },
      DATES: {
        CLICK: 'MainSearchFormDatesClick',
        SELECT: 'MainSearchFormDatesSelect',
      },
      SUBMIT: 'MainSearchFormSubmit',
      VALIDATION_ERROR: 'MainSearchFormValidationError',
    },
  },
  SEARCH: {
    LOAD: {
      SUCCESS: 'SearchLoadSuccess',
      ERROR: 'SearchLoadError',
    },
    ERROR: {
      RETRY_BUTTON_CLICK: 'SearchErrorRetryButtonClick',
      CLOSE_BUTTON_CLICK: 'SearchErrorCloseButtonClick',
    },
    HOTEL: {
      SELECT: 'SearchHotelSelect',
      OPEN_DETAILS: 'SearchHotelOpenDetails',
      SELECT_FROM_DETAILS: 'SearchHotelSelectFromDetails',
    },
    CLOSE_SEARCH_VIEW: 'SearchCloseView',
    EDIT_SEARCH_PARAMS: 'SearchEditSearchParams',
    EMPTY_RESULTS: 'SearchEmptyResults',
  },
  REQUEST: {
    RETRY: 'RequestRetry',
    ERROR: 'RequestError',
    SUCCESS: 'RequestSuccess',
    VALIDATION_ERROR: 'RequestValidationError',
    CLICK_REQUEST_BUTTON: 'RequestClickRequestButton',
  },
};

export const TOURDER = {
  PREFIX: 'Tourder',
  TOWN_FROM: {
    OPEN: 'TownFromPageOpen',
    CLICK: 'TownFromClick',
    SELECT: 'TownFromSelect',
    PROCEED: 'TownFromProceed',
  },
  TOWN_TO: {
    OPEN: 'TownToPageOpen',
    CLICK: 'TownToClick',
    SELECT_COUNTRY: 'TownToSelectCountry',
    SELECT_TOWNS_TO: 'TownToSelectTownsTo',
    SUBMIT: 'TownToSubmit',
    PROCEED: 'TownToProceed',
  },
  DATES: {
    OPEN: 'DatesPageOpen',
    CLICK: 'DatesClick',
    SELECT: 'DatesSelect',
    PROCEED: 'DatesProceed',
  },
  PASSENGERS: {
    OPEN: 'PassengersPageOpen',
    SELECT_ADULTS: 'PassengersSelectAdults',
    SELECT_CHILDREN: 'PassengersSelectChildren',
    SUBMIT: 'PassengersSubmit',
  },
  BUDGET: {
    OPEN: 'BudgetPageOpen',
    SELECT: 'BudgetSelect',
    SUBMIT: 'BudgetSubmit',
    NOT_IMPORTANT: 'BudgetNotImportantSelect',
  },
  FILTERS: {
    OPEN: 'FiltersPageOpen',
    SELECT: 'FiltersSelect',
    UNSELECT: 'FiltersUnselect',
    SUBMIT: 'FiltersSubmit',
  },
};

export const HOT_TOURS = {
  PREFIX: 'HotTours',
  PAGE: {
    LOAD: {
      SUCCESS: 'PageLoadSuccess',
      ERROR: 'PageLoadError',
    },
  },
  DEPARTURE_CITY: {
    OPEN: 'DepartureCityOpen',
    SELECT: 'DepartureCitySelect',
  },
  COUNTRY: {
    SELECT: 'CountryTabSelect',
  },
  FILTERS: {
    OPEN: 'FiltersOpen',
    APPLY: 'FiltersApply',
    RESET: 'FiltersReset',
  },
  SORTING: {
    OPEN: 'SortingOpen',
    CHANGE: 'SortingChange',
  },
  OFFER: {
    CLICK: 'OfferCardClick',
  },
  CASHBACK: {
    INFO_OPEN: 'CashbackInfoOpen',
  },
  SUPER_APP: {
    CTA_CLICK: 'SuperAppCtaClick',
  },
};
